module.exports = __webpack_public_path__ + "static/img/xw.efc2d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xw.png
// module id = rE/u
// module chunks = 0